import { Button } from 'ii-react-sdk/form_components';
import React from 'react';
import { useContentLibrary } from '../../../providers/content_library_provider';
import ClearSelectedDocumentsButton from './clearSelectedDocumentsButton';
const ButtonsContainer = () => {
    const { selectedDocuments, createComparison, isCreatingComparison } = useContentLibrary();
    const ActionButton = () => (React.createElement(Button, { "data-testid": 'compare-selected-documents-button', className: 'selected-documents-button', id: 'compare-documents-button', onClick: createComparison, disabled: !(selectedDocuments === null || selectedDocuments === void 0 ? void 0 : selectedDocuments.length) ||
            isCreatingComparison ||
            (selectedDocuments === null || selectedDocuments === void 0 ? void 0 : selectedDocuments.length) < 2 }, !isCreatingComparison
        ? 'Compare'
        : React.createElement("span", null,
            React.createElement("i", { className: 'fas fa-spin fa-spinner' }))));
    return React.createElement("div", { className: 'buttons-container' },
        React.createElement(ClearSelectedDocumentsButton, null),
        React.createElement(ActionButton, null));
};
export default ButtonsContainer;
